import { useState } from 'react'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline'

const faqs = [
	{
		question: 'What do you need to sign up?',
		answer: 'An active email address.',
	},
	{
		question: 'How do can I cancel my subscription?',
		answer:
			'Just head into settings page on Chrome Extension or website and click "Manage Subscription". You can cancel your subscription there.',
	},
	{
		question: 'How does your pricing work? Are there any hidden fees?',
		answer: 'Our pricing model is transparent with no hidden fees.',
	},
	{
		question: 'What types of payment do you accept?',
		answer:
			'We accept payments through Stripe, which supports a wide range of global card networks.',
	},
	{
		question: 'How can I contact customer support?',
		answer:
			'You can contact us via email <a href="mailto:info@loadfetcher.com" class="text-blue-600 font-semibold hover:underline">info@loadfetcher.com</a> or via Telegram chat <a href="https://t.me/loadfetcher_support" class="text-blue-600 font-semibold hover:underline">@loadfetcher_support</a>. We usually respond within 1-24 hours.',
	},
	{
		question: 'What is your cancellation policy?',
		answer:
			"You're free to cancel your subscription at any time; the service will remain active until the end of your current billing cycle.",
	},
	{
		question: 'How often do you release new features or updates?',
		answer:
			'We consistently roll out new features and updates to enhance your experience.',
	},
	{
		question:
			'Is there a free trial available, and do I need a credit card to sign up?',
		answer:
			"While we don't offer a free trial, we do have a free tier available that you can use without providing payment information. This allows you to explore our basic features at no cost. For access to premium features, please visit our pricing page to choose a paid plan that best suits your needs. Payment information is required only when signing up for a paid subscription.",
	},
]

export default function Faqs() {
	const [openIndex, setOpenIndex] = useState(null)

	const toggleFaq = index => {
		setOpenIndex(openIndex === index ? null : index)
	}

	return (
		<div id="faq" className="bg-white border-t border-gray-100">
			<div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8 sm:py-12 md:py-16">
				<div className="mx-auto max-w-4xl">
					<h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-gray-900">
						Frequently asked questions
					</h2>
					<dl className="mt-8 sm:mt-12 md:mt-16 divide-y divide-gray-900/10">
						{faqs.map((faq, index) => (
							<div
								key={faq.question}
								className="py-4 sm:py-6 first:pt-0 last:pb-0"
							>
								<dt>
									<button
										onClick={() => toggleFaq(index)}
										className="flex w-full items-start justify-between text-left text-gray-900 focus:outline-none rounded-md"
									>
										<span className="text-sm sm:text-base font-semibold leading-6 sm:leading-7 pr-2">
											{faq.question}
										</span>
										<span className="ml-6 flex h-7 items-center">
											{openIndex === index ? (
												<MinusSmallIcon
													aria-hidden="true"
													className="h-6 w-6"
												/>
											) : (
												<PlusSmallIcon aria-hidden="true" className="h-6 w-6" />
											)}
										</span>
									</button>
								</dt>
								{openIndex === index && (
									<dd className="mt-2 pr-12">
										<p
											className="text-base sm:text-md leading-7 sm:leading-8 text-gray-600"
											dangerouslySetInnerHTML={{ __html: faq.answer }}
										></p>
									</dd>
								)}
							</div>
						))}
					</dl>
				</div>
			</div>
		</div>
	)
}
